<div class="container-fluid d-flex flex-row justify-content-center mb-0 mt-1 pt-1 pb-0 shadow-lg col-12 col-lg-11">
  <div class="jumbotron-fluid mb-0 pb-0">
    <!-- this is for personal info -->
    <div [hidden]="!showPersonalForm">
      <div class="container my-2 mx-0 shadow-lg">
        <div class="row">
          <div class="col-12">
            <h4 class="rub-head4 text-info text-center font-weight-bold py-1">
              Personal Info
            </h4>
          </div>
        </div>
      </div>
      <div class="card-body mt-1 pt-4 mb-0 pb-3 shadow-lg">
        <form [formGroup]="userForm">
          <div class="row">
            <div class="col-12">
              <div class="d-flex mt-0 mb-2 py-0 mx-auto">
                <div
                  *ngIf="checkedStation"
                  class="row"
                >
                  <div class="col-12 text-left text-info h6"><strong>Selected Station Details</strong></div>
                  <div class="col-6">ID: <strong>{{checkedStation.stationId}} </strong></div>
                  <div class="col-6">Name: <strong>{{checkedStation.stationName}} </strong></div>
                  <div class="col-6">Location ID: <strong>{{checkedStation.theStationLocationId}}</strong></div>
                  <div class="col-6">Status: <strong>APPROVED</strong></div>
                </div>
              </div>
              <div class="d-flex mt-0 mb-2 py-0 mx-auto">
                <button
                  (click)="selectFromData(dataModal, 200)"
                  class="btn btn-info col-5 mx-auto"
                  type="button"
                >
                  Select Station
                </button>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-md-6">
              <div class="form-group text-primary">
                <label
                  for="customer_name"
                  [ngClass]="fval.customer_name.valid ? 'text-info' : ''"
                >Client Name<i
                    *ngIf="fval.customer_name.valid"
                    class="material-icons"
                  >check_circle</i></label>
                <div class="input-group mb-0">
                  <div class="input-group-prepend">
                    <div class="input-group-text">
                      <i
                        class="fas fa-user-alt text-primary mx-auto"
                        style="size: 50px;"
                      >
                      </i>
                    </div>
                  </div>
                  <input
                    type="text"
                    formControlName="customer_name"
                    class="form-control"
                    [ngClass]="{
                    'is-invalid':
                      (fval.customer_name.touched ||
                        fval.customer_name.dirty) &&
                      fval.customer_name.errors
                  }"
                    autocomplete="off"
                    placeholder="Enter Customer Name"
                  />
                </div>
                <div
                  class="text-danger col"
                  *ngIf="
                  (fval.customer_name.touched || fval.customer_name.dirty) &&
                  fval.customer_name.errors?.required
                "
                >
                  The client name is required!
                </div>
              </div>
            </div>
            <div class="col-12 col-md-6">
              <div class="form-group text-primary">
                <label
                  for="homeDetails"
                  [ngClass]="fval.homeDetails.valid ? 'text-info' : ''"
                >Home Details<i
                    *ngIf="fval.homeDetails.valid"
                    class="material-icons"
                  >check_circle</i></label>
                <div class="input-group mb-0">
                  <div class="input-group-prepend">
                    <div class="input-group-text">
                      <i
                        class="fas fa-location-arrow text-primary mx-auto"
                        style="size: 50px;"
                      >
                      </i>
                    </div>
                  </div>
                  <input
                    type="text"
                    formControlName="homeDetails"
                    class="form-control"
                    [ngClass]="{
                    'is-invalid':
                      (fval.homeDetails.touched || fval.homeDetails.dirty) &&
                      fval.homeDetails.errors
                  }"
                    autocomplete="off"
                    placeholder="Enter Home Details"
                  />
                </div>
                <div
                  class="text-danger col"
                  *ngIf="
                  (fval.homeDetails.touched || fval.homeDetails.dirty) &&
                  fval.homeDetails.errors?.required
                "
                >
                  The home details are required!
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-md-6">
              <div class="form-group text-primary">
                <label
                  for="main_contact_number1"
                  [ngClass]="fval.main_contact_number1.valid ? 'text-info' : ''"
                >Phone Number 1<i
                    *ngIf="fval.main_contact_number1.valid"
                    class="material-icons"
                  >check_circle</i></label>
                <div class="input-group mb-0">
                  <div class="input-group-prepend">
                    <div class="input-group-text">
                      <i
                        class="fas fa-phone text-primary mx-auto"
                        style="size: 50px;"
                      ></i>
                    </div>
                  </div>
                  <input
                    id="main_contact_number1"
                    formControlName="main_contact_number1"
                    type="text"
                    class="form-control"
                    [ngClass]="{
                    'is-invalid':
                      (fval.main_contact_number1.touched ||
                        fval.main_contact_number1.dirty) &&
                      fval.main_contact_number1.errors
                  }"
                    placeholder="e.g. 07XXXXXXXX"
                    autocomplete="off"
                  />
                </div>
                <div
                  class="text-danger col"
                  *ngIf="
                  (fval.main_contact_number1.touched ||
                    fval.main_contact_number1.dirty) &&
                  fval.main_contact_number1.errors?.required
                "
                >
                  The phone number is required!
                </div>
                <div
                  class="text-danger col"
                  *ngIf="
                  (fval.main_contact_number1.touched ||
                    fval.main_contact_number1.dirty) &&
                  fval.main_contact_number1.errors?.hasNumber
                "
                >
                  The phone number should be equal to 10 "digits"!
                </div>
              </div>
            </div>
            <div class="col-12 col-md-6">
              <div class="form-group text-primary">
                <label
                  for="main_contact_number2"
                  [ngClass]="fval.main_contact_number2.valid ? 'text-info' : ''"
                >Phone Number 2(Optional)
                  <!-- <i
                  *ngIf="fval.main_contact_number2.valid"
                  class="material-icons"
                  >check_circle</i
                > -->
                </label>
                <div class="input-group mb-0">
                  <div class="input-group-prepend">
                    <div class="input-group-text">
                      <i
                        class="fas fa-phone text-primary mx-auto"
                        style="size: 50px;"
                      ></i>
                    </div>
                  </div>
                  <input
                    id="main_contact_number2"
                    formControlName="main_contact_number2"
                    type="text"
                    class="form-control"
                    [ngClass]="{
                    'is-invalid':
                      (fval.main_contact_number2.touched ||
                        fval.main_contact_number2.dirty) &&
                      fval.main_contact_number2.errors
                  }"
                    placeholder="e.g. 07XXXXXXXX (Optional)"
                    autocomplete="off"
                  />
                </div>
                <div
                  class="text-danger col"
                  *ngIf="
                  (fval.main_contact_number2.touched ||
                    fval.main_contact_number2.dirty) &&
                  fval.main_contact_number2.errors?.hasNumber
                "
                >
                  The phone number should be equal to 10 "digits"!
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-md-6">
              <div class="form-group text-primary">
                <label
                  for="id_type"
                  [ngClass]="fval.id_type.valid? 'text-info' : ''"
                >ID Type<i
                    *ngIf="fval.id_type.valid"
                    class="material-icons"
                  >check_circle</i></label>
                <div class="input-group mb-0">
                  <div class="input-group-prepend">
                    <div class="input-group-text">
                      <i
                        class="fas fa-user-tag text-primary mx-auto"
                        style="size: 50px;"
                      >
                      </i>
                    </div>
                  </div>
                  <select
                    (change)='setSelectedChanges(fval.id_type.value)'
                    [ngClass]="{
            'is-invalid':
              (fval.id_type.touched || fval.id_type.dirty) &&
              fval.id_type.errors
          }"
                    autocomplete="off"
                    class="form-control"
                    formControlName="id_type"
                  >
                    <option
                      class="place-holder-select"
                      disabled
                      hidden
                      selected
                      value=""
                    >Select ID Type</option>
                    <option>NATIONAL ID</option>
                    <option>PASSPORT</option>
                    <option>DRIVING PERMIT</option>
                    <option>VILLAGE ID</option>
                  </select>
                </div>
                <div
                  class="text-danger col"
                  *ngIf="
                  (fval.id_type.touched || fval.id_type.dirty) &&
                  fval.id_type.errors?.required
                "
                >
                  The ID type is required!
                </div>
              </div>
            </div>
            <div class="col-12 col-md-6">
              <div class="form-group text-primary">
                <label
                  for="id_number"
                  [ngClass]="fval.id_number.valid ? 'text-info' : ''"
                >ID Number<i
                    *ngIf="fval.id_number.valid"
                    class="material-icons"
                  >check_circle</i></label>
                <div class="input-group mb-0">
                  <div class="input-group-prepend">
                    <div class="input-group-text">
                      <i
                        class="fas fa-tag text-primary mx-auto"
                        style="size: 50px;"
                      ></i>
                    </div>
                  </div>
                  <input
                    id="id_number"
                    formControlName="id_number"
                    type="text"
                    class="form-control"
                    [ngClass]="{
                    'is-invalid':
                      (fval.id_number.touched || fval.id_number.dirty) &&
                      fval.id_number.errors
                  }"
                    placeholder="Enter your ID number"
                    autocomplete="off"
                  />
                </div>
                <div
                  class="text-danger col"
                  *ngIf="
                  (fval.id_number.touched || fval.id_number.dirty) &&
                  fval.id_number.errors?.required
                "
                >
                  The ID number is required!
                </div>
                <div
                  class="text-danger col"
                  *ngIf="
                  (fval.id_number.touched || fval.id_number.dirty) &&
                  fval.id_number.errors?.nationalIdCheck
                "
                >
                  Please enter valid ID number!
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-md-6">
              <div class="form-group text-primary">
                <label
                  for="clientPhotoUrl"
                  [ngClass]="fval.clientPhotoUrl.valid ? 'text-info' : ''"
                >Client's Photo<i
                    *ngIf="fval.clientPhotoUrl.valid"
                    class="material-icons"
                  >check_circle</i></label>
                <div class="input-group mb-0">
                  <div class="input-group-prepend">
                    <div class="input-group-text">
                      <i
                        class="fas fa-image text-primary mx-auto"
                        style="size: 50px;"
                      ></i>
                    </div>
                  </div>
                  <input
                    id="clientPhotoUrl"
                    formControlName="clientPhotoUrl"
                    type="file"
                    src="image/*"
                    capture
                    (change)="onFileSelected($event)"
                    class="form-control"
                    [ngClass]="{
                    'is-invalid':
                      (fval.clientPhotoUrl.touched ||
                        fval.clientPhotoUrl.dirty) &&
                      fval.clientPhotoUrl.errors
                  }"
                  />
                </div>
                <div
                  class="text-danger col"
                  *ngIf="
                  (fval.clientPhotoUrl.touched || fval.clientPhotoUrl.dirty) &&
                  fval.clientPhotoUrl.errors?.required
                "
                >
                  Please upload a passport-size photo of the client!
                </div>
              </div>
            </div>
            <div class="col-12 col-md-6">
              <div class="form-group text-primary">
                <label
                  for="idPhotoUrl"
                  [ngClass]="fval.idPhotoUrl.valid ? 'text-info' : ''"
                >ID Upload<i
                    *ngIf="fval.idPhotoUrl.valid"
                    class="material-icons"
                  >check_circle</i></label>
                <div class="input-group mb-0">
                  <div class="input-group-prepend">
                    <div class="input-group-text">
                      <i
                        class="fas fa-image text-primary mx-auto"
                        style="size: 50px;"
                      ></i>
                    </div>
                  </div>
                  <input
                    id="idPhotoUrl"
                    formControlName="idPhotoUrl"
                    type="file"
                    src="image/*"
                    capture
                    (change)="onFileSelected($event)"
                    class="form-control"
                    [ngClass]="{
                    'is-invalid':
                      (fval.idPhotoUrl.touched ||
                        fval.idPhotoUrl.dirty) &&
                      fval.idPhotoUrl.errors
                  }"
                  />
                </div>
                <div
                  class="text-danger col"
                  *ngIf="
                  (fval.idPhotoUrl.touched || fval.idPhotoUrl.dirty) &&
                  fval.idPhotoUrl.errors?.required
                "
                >
                  Please upload a photo of the client's ID'!
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-md-6">
              <div class="form-group text-primary">
                <label
                  for="dateOfBirth"
                  [ngClass]="fval.dateOfBirth.valid ? 'text-info' : ''"
                >Date Of Birth<i
                    *ngIf="fval.dateOfBirth.valid"
                    class="material-icons"
                  >check_circle</i></label>
                <div class="input-group mb-0">
                  <div class="input-group-prepend">
                    <div class="input-group-text">
                      <i
                        class="fas fa-calendar-alt text-primary mx-auto"
                        style="size: 50px;"
                      ></i>
                    </div>
                  </div>
                  <input
                    id="dateOfBirth"
                    formControlName="dateOfBirth"
                    type="text"
                    class="form-control"
                    [ngClass]="{
                    'is-invalid':
                      (fval.dateOfBirth.touched || fval.dateOfBirth.dirty) &&
                      fval.dateOfBirth.errors
                  }"
                    placeholder="Click to select Date Of Birth"
                    autocomplete="off"
                    bsDatepicker
                    [bsConfig]="{ containerClass:'theme-blue', dateInputFormat: 'MM/DD/YYYY', isAnimated: true }"
                    placement="top"
                  />
                </div>
                <div
                  class="text-danger col"
                  *ngIf="
                  (fval.dateOfBirth.touched || fval.dateOfBirth.dirty) &&
                  fval.dateOfBirth.errors?.required
                "
                >
                  Date Of Birth is required!
                </div>
              </div>
            </div>
            <div class="col-12 col-md-6">
              <div class="form-group text-primary">
                <label
                  for="productCode"
                  [ngClass]="fval.productCode.valid && fval.productCode.value !== 'Initial Product' ? 'text-info' : ''"
                >Initial Product
                  <i
                    *ngIf="fval.productCode.valid && fval.productCode.value !== 'Initial Product'"
                    class="material-icons"
                  >check_circle</i>
                </label>
                <div class="input-group mb-0">
                  <select
                    [ngClass]="{
            'is-invalid':
              (fval.productCode.touched || fval.productCode.dirty) &&
              fval.productCode.errors
          }"
                    autocomplete="off"
                    class="form-control"
                    formControlName="productCode"
                  >
                    <option
                      class="place-holder-select"
                      disabled
                      hidden
                      selected
                      value=""
                    >Select Product</option>
                    <option
                      *ngFor="let i of products"
                      [value]="i.productCode"
                    >{{i.productName}}</option>
                  </select>
                </div>
                <div
                  class="text-danger col"
                  *ngIf="
                (fval.productCode.touched || fval.productCode.dirty) &&
                fval.productCode.errors?.required
              "
                >
                  initial product is required
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-md-9">
              <div class="form-group text-primary">
                <div class="input-group mb-0">
                  <textarea
                    id="clientComment"
                    formControlName="clientComment"
                    class="form-control"
                    [ngClass]="{
                    'is-invalid':
                      (fval.clientComment.touched ||
                        fval.clientComment.dirty) &&
                      fval.clientComment.errors
                  }"
                    placeholder="Client comment"
                  ></textarea>
                </div>
                <div
                  class="text-danger col"
                  *ngIf="
                  (fval.clientComment.touched || fval.clientComment.dirty) &&
                  fval.clientComment.errors?.required
                "
                >
                  Comment on the client is required!
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>

    <!-- this is for boda client -->
    <div [hidden]="!showBodaForm">
      <div class="container my-2 mx-0 shadow-lg col-12">
        <div class="row">
          <div class="col-12">
            <h4 class="rub-head4 text-info text-center font-weight-bold py-1">
              Boda Client Info
            </h4>
          </div>
        </div>
      </div>
      <div class="card-body mt-1 pt-4 mb-0 mb-md-3 pb-3 shadow-lg">
        <form [formGroup]="bodaClientForm">
          <div class="row">
            <div class="col-12 col-md-6">
              <div class="form-group text-primary">
                <label
                  for="clientName"
                  [ngClass]="bodaFval.clientName.valid ? 'text-info' : ''"
                >Client Name<i
                    *ngIf="bodaFval.clientName.valid"
                    class="material-icons"
                  >check_circle</i></label>
                <div class="input-group mb-0">
                  <div class="input-group-prepend">
                    <div class="input-group-text">
                      <i
                        class="fas fa-user-alt text-primary mx-auto"
                        style="size: 50px;"
                      >
                      </i>
                    </div>
                  </div>
                  <input
                    type="text"
                    formControlName="clientName"
                    class="form-control"
                    [ngClass]="{
                'is-invalid':
                  (bodaFval.clientName.touched || bodaFval.clientName.dirty) &&
                  bodaFval.clientName.errors
              }"
                    autocomplete="off"
                    placeholder="Enter Customer Name"
                  />
                </div>
                <div
                  class="text-danger col"
                  *ngIf="
                (bodaFval.clientName.touched || bodaFval.clientName.dirty) &&
                bodaFval.clientName.errors?.required
              "
                >
                  The client name is required!
                </div>
              </div>
            </div>
            <div class="col-12 col-md-6">
              <div class="form-group text-primary">
                <label
                  for="bodabodaCustomerNumberPlate"
                  [ngClass]="
              bodaFval.bodabodaCustomerNumberPlate.valid ? 'text-info' : ''
              "
                >Number Plate<i
                    *ngIf="bodaFval.bodabodaCustomerNumberPlate.valid"
                    class="material-icons"
                  >check_circle</i></label>
                <div class="input-group mb-0">
                  <div class="input-group-prepend">
                    <div class="input-group-text">
                      <i
                        class="fas fa-tag text-primary mx-auto"
                        style="size: 50px;"
                      >
                      </i>
                    </div>
                  </div>
                  <input
                    type="text"
                    formControlName="bodabodaCustomerNumberPlate"
                    class="form-control"
                    [ngClass]="{
                  'is-invalid':
                    (bodaFval.bodabodaCustomerNumberPlate.touched ||
                    bodaFval.bodabodaCustomerNumberPlate.dirty) &&
                    bodaFval.bodabodaCustomerNumberPlate.errors
                }"
                    autocomplete="off"
                    placeholder="Enter Bodaboda number plate"
                  />
                </div>
                <div
                  class="text-danger col"
                  *ngIf="
                (bodaFval.bodabodaCustomerNumberPlate.touched ||
                bodaFval.bodabodaCustomerNumberPlate.dirty) &&
                bodaFval.bodabodaCustomerNumberPlate.errors?.required
              "
                >
                  The Bodaboda number plate is required!
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-md-6">
              <div class="form-group text-primary">
                <label
                  for="bodaMakeorType"
                  [ngClass]="
                bodaFval.bodaMakeorType.valid ? 'text-info' : ''
                "
                >Bodaboda Make Or Type<i
                    *ngIf="bodaFval.bodaMakeorType.valid"
                    class="material-icons"
                  >check_circle</i></label>
                <div class="input-group mb-0">
                  <input
                    type="text"
                    formControlName="bodaMakeorType"
                    class="form-control"
                    [ngClass]="{
                    'is-invalid':
                      (bodaFval.bodaMakeorType.touched ||
                      bodaFval.bodaMakeorType.dirty) &&
                      bodaFval.bodaMakeorType.errors
                  }"
                    autocomplete="off"
                    placeholder="Bodaboda make or type"
                  />
                </div>
                <div
                  class="text-danger col"
                  *ngIf="
                  (bodaFval.bodaMakeorType.touched ||
                  bodaFval.bodaMakeorType.dirty) &&
                  bodaFval.bodaMakeorType.errors?.required
                "
                >
                  The bodaboda make/type is required!
                </div>
              </div>
            </div>
            <div class="col-12 col-md-6">
              <div class="form-group text-primary">
                <label
                  for="bodaInsuarance"
                  [ngClass]="
                bodaFval.bodaInsuarance.valid ? 'text-info' : ''
                "
                >Bodaboda Insurance<i
                    *ngIf="bodaFval.bodaInsuarance.valid"
                    class="material-icons"
                  >check_circle</i></label>
                <div class="input-group mb-0">
                  <select
                    [ngClass]="{
            'is-invalid':
              (bodaFval.bodaInsuarance.touched || bodaFval.bodaInsuarance.dirty) &&
              bodaFval.bodaInsuarance.errors
          }"
                    autocomplete="off"
                    class="form-control"
                    formControlName="bodaInsuarance"
                  >
                    <option
                      class="place-holder-select"
                      disabled
                      hidden
                      selected
                      value=""
                    >Select Insurance Type</option>
                    <option>NONE</option>
                    <option>REGULAR</option>
                    <option>COMPREHENSIVE</option>
                  </select>
                </div>
                <div
                  class="text-danger col"
                  *ngIf="
                  (bodaFval.bodaInsuarance.touched ||
                  bodaFval.bodaInsuarance.dirty) &&
                  bodaFval.bodaInsuarance.errors?.required
                "
                >
                  The bodaboda insurance is required!
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-md-6">
              <div class="form-group text-primary">
                <label
                  for="bodaStage"
                  [ngClass]="
                bodaFval.bodaStage.valid ? 'text-info' : ''
                "
                >Bodaboda Stage<i
                    *ngIf="bodaFval.bodaStage.valid"
                    class="material-icons"
                  >check_circle</i></label>
                <div class="input-group mb-0">
                  <input
                    type="text"
                    list="bodaStage"
                    formControlName="bodaStage"
                    class="form-control"
                    [ngClass]="{
                  'is-invalid':
                    (bodaFval.bodaStage.touched ||
                    bodaFval.bodaStage.dirty) &&
                    bodaFval.bodaStage.errors
                }"
                    autocomplete="off"
                    placeholder="Select a bodaboda stage"
                  />
                  <!-- parks -->
                  <datalist id="bodaStage">
                    <option *ngFor="let bodaStage of bodaStages">
                      {{ bodaStage.bodabodaStageName }}
                    </option>
                  </datalist>
                </div>
                <div
                  class="text-danger col"
                  *ngIf="
                  (bodaFval.bodaStage.touched ||
                  bodaFval.bodaStage.dirty) &&
                  bodaFval.bodaStage.errors?.required
                "
                >
                  Bodaboda stage is required!
                </div>
              </div>
            </div>
            <div class="col-12 col-md-6">
              <div class="form-group text-primary">
                <label
                  for="dateOfJoiningStage"
                  [ngClass]="
                bodaFval.dateOfJoiningStage.valid
                    ? 'text-info'
                    : ''
                "
                >Date Of Joining Stage<i
                    *ngIf="bodaFval.dateOfJoiningStage.valid"
                    class="material-icons"
                  >check_circle</i></label>
                <div class="input-group mb-0">
                  <div class="input-group-prepend">
                    <div class="input-group-text">
                      <i
                        class="fas fa-calendar-alt text-primary mx-auto"
                        style="size: 50px;"
                      >
                      </i>
                    </div>
                  </div>
                  <input
                    id="bodaDateOfJoiningStage"
                    formControlName="dateOfJoiningStage"
                    type="text"
                    [ngClass]="{
                    'is-invalid':
                      (bodaFval.dateOfJoiningStage.touched
                      || bodaFval.dateOfJoiningStage.dirty) &&
                      bodaFval.dateOfJoiningStage.errors
                  }"
                    placeholder="Click to select Date"
                    autocomplete="off"
                    class="form-control"
                    bsDatepicker
                    [bsConfig]="{ containerClass:'theme-blue', dateInputFormat: 'MM/DD/YYYY', isAnimated: true }"
                    placement="top"
                  />
                </div>
                <div
                  class="text-danger col"
                  *ngIf="
                  (bodaFval.dateOfJoiningStage.touched ||
                  bodaFval.dateOfJoiningStage.dirty) &&
                  bodaFval.dateOfJoiningStage.errors?.required
                "
                >
                  Date of joining stage is required!
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-md-6">
              <div class="form-group text-primary">
                <label
                  for="bodabodaCustomerFrontPhotoUrl"
                  [ngClass]="bodaFval.bodabodaCustomerFrontPhotoUrl.valid ? 'text-info' : ''"
                >Front Image<i
                    *ngIf="bodaFval.bodabodaCustomerFrontPhotoUrl.valid"
                    class="material-icons"
                  >check_circle</i></label>
                <div class="input-group mb-0">
                  <div class="input-group-prepend">
                    <div class="input-group-text">
                      <i
                        class="fas fa-image text-primary mx-auto"
                        style="size: 50px;"
                      ></i>
                    </div>
                  </div>
                  <input
                    id="bodabodaCustomerFrontPhotoUrl"
                    formControlName="bodabodaCustomerFrontPhotoUrl"
                    type="file"
                    src="image/*"
                    capture
                    (change)="onFileSelected($event)"
                    class="form-control"
                    [ngClass]="{
                    'is-invalid':
                      (bodaFval.bodabodaCustomerFrontPhotoUrl.touched ||
                      bodaFval.bodabodaCustomerFrontPhotoUrl.dirty) &&
                      bodaFval.bodabodaCustomerFrontPhotoUrl.errors
                  }"
                  />
                </div>
                <div
                  class="text-danger col"
                  *ngIf="
                  (bodaFval.bodabodaCustomerFrontPhotoUrl.touched || bodaFval.bodabodaCustomerFrontPhotoUrl.dirty) &&
                  bodaFval.bodabodaCustomerFrontPhotoUrl.errors?.required
                "
                >
                  Please upload a front image of bodaboda!
                </div>
              </div>
            </div>
            <div class="col-12 col-md-6">
              <div class="form-group text-primary">
                <label
                  for="bodabodaCustomerSidePhotoUrl"
                  [ngClass]="bodaFval.bodabodaCustomerSidePhotoUrl.valid ? 'text-info' : ''"
                >Side Image<i
                    *ngIf="bodaFval.bodabodaCustomerSidePhotoUrl.valid"
                    class="material-icons"
                  >check_circle</i></label>
                <div class="input-group mb-0">
                  <div class="input-group-prepend">
                    <div class="input-group-text">
                      <i
                        class="fas fa-image text-primary mx-auto"
                        style="size: 50px;"
                      ></i>
                    </div>
                  </div>
                  <input
                    id="bodabodaCustomerSidePhotoUrl"
                    formControlName="bodabodaCustomerSidePhotoUrl"
                    type="file"
                    src="image/*"
                    capture
                    (change)="onFileSelected($event)"
                    class="form-control"
                    [ngClass]="{
                    'is-invalid':
                      (bodaFval.bodabodaCustomerSidePhotoUrl.touched ||
                      bodaFval.bodabodaCustomerSidePhotoUrl.dirty) &&
                      bodaFval.bodabodaCustomerSidePhotoUrl.errors
                  }"
                  />
                </div>
                <div
                  class="text-danger col"
                  *ngIf="
                  (bodaFval.bodabodaCustomerSidePhotoUrl.touched || bodaFval.bodabodaCustomerSidePhotoUrl.dirty) &&
                  bodaFval.bodabodaCustomerSidePhotoUrl.errors?.required
                "
                >
                  Please upload a side image of bodaboda!
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-md-6">
              <div class="form-group text-primary">
                <label
                  for="bodabodaCustomerRearPhotoUrl"
                  [ngClass]="bodaFval.bodabodaCustomerRearPhotoUrl.valid ? 'text-info' : ''"
                >Rear Image<i
                    *ngIf="bodaFval.bodabodaCustomerRearPhotoUrl.valid"
                    class="material-icons"
                  >check_circle</i></label>
                <div class="input-group mb-0">
                  <div class="input-group-prepend">
                    <div class="input-group-text">
                      <i
                        class="fas fa-image text-primary mx-auto"
                        style="size: 50px;"
                      ></i>
                    </div>
                  </div>
                  <input
                    id="bodabodaCustomerRearPhotoUrl"
                    formControlName="bodabodaCustomerRearPhotoUrl"
                    type="file"
                    src="image/*"
                    capture
                    (change)="onFileSelected($event)"
                    class="form-control"
                    [ngClass]="{
                    'is-invalid':
                      (bodaFval.bodabodaCustomerRearPhotoUrl.touched ||
                      bodaFval.bodabodaCustomerRearPhotoUrl.dirty) &&
                      bodaFval.bodabodaCustomerRearPhotoUrl.errors
                  }"
                  />
                </div>
                <div
                  class="text-danger col"
                  *ngIf="
                  (bodaFval.bodabodaCustomerRearPhotoUrl.touched || bodaFval.bodabodaCustomerRearPhotoUrl.dirty) &&
                  bodaFval.bodabodaCustomerRearPhotoUrl.errors?.required
                "
                >
                  Please upload a rear image of bodaboda!
                </div>
              </div>
            </div>
            <div class="col-12 col-md-6">
              <div class="form-group text-primary">
                <label
                  for="ownershipStatus"
                  [ngClass]="bodaFval.ownershipStatus.valid ? 'text-info' : ''"
                >Bodaboda Ownership Status<i
                    *ngIf="bodaFval.ownershipStatus.valid"
                    class="material-icons"
                  >check_circle</i></label>
                <div class="input-group mb-0">
                  <select
                    (change)='setSelectedChanges(bodaFval.ownershipStatus.value)'
                    [ngClass]="{
            'is-invalid':
              (bodaFval.ownershipStatus.touched ||bodaFval.ownershipStatus.dirty) &&
           bodaFval.ownershipStatus.errors
          }"
                    autocomplete="off"
                    class="form-control"
                    formControlName="ownershipStatus"
                  >
                    <option
                      class="place-holder-select"
                      disabled
                      hidden
                      selected
                      value=""
                    >Select Status</option>
                    <option>ONLOAN</option>
                    <option>PAIDOUT</option>
                    <option>HIREDOUT</option>
                  </select>
                </div>
                <div
                  class="text-danger col"
                  *ngIf="
                  (bodaFval.ownershipStatus.touched || bodaFval.ownershipStatus.dirty) &&
                  bodaFval.ownershipStatus.errors?.required
                "
                >
                  Bodaboda ownership status is required!
                </div>
              </div>
            </div>
          </div>
          <div
            class="row"
            *ngIf=" bodaFval.ownershipStatus.value == 'ONLOAN' || bodaFval.ownershipStatus.value == 'HIREDOUT' "
          >
            <div class="col-12 col-md-6">
              <div class="form-group text-primary">
                <label
                  for="bodaOwnersName"
                  [ngClass]="bodaFval.ownersName.valid ? 'text-info' : ''"
                >Bodaboda Owner's Name<i
                    *ngIf="bodaFval.ownersName.valid"
                    class="material-icons"
                  >check_circle</i></label>
                <div class="input-group mb-0">
                  <div class="input-group-prepend">
                    <div class="input-group-text">
                      <i
                        class="fas fa-user-alt text-primary mx-auto"
                        style="size: 50px;"
                      ></i>
                    </div>
                  </div>
                  <input
                    id="bodaOwnersName"
                    formControlName="ownersName"
                    type="text"
                    placeholder="Bodaboda owner's name"
                    class="form-control"
                    [ngClass]="{
                    'is-invalid':
                      (bodaFval.ownersName.touched ||
                      bodaFval.ownersName.dirty) &&
                      bodaFval.ownersName.errors
                  }"
                  />
                </div>
                <div
                  class="text-danger col"
                  *ngIf="
                  (bodaFval.ownersName.touched || bodaFval.ownersName.dirty) &&
                  bodaFval.ownersName.errors?.required
                "
                >
                  Bodaboda owner's name is required!
                </div>
              </div>
            </div>
            <div class="col-12 col-md-6">
              <div class="form-group text-primary">
                <label
                  for="bodaOwnersPhoneNumber"
                  [ngClass]="bodaFval.ownersPhoneNumber.valid ? 'text-info' : ''"
                >Bodaboda Owner's Phone Number<i
                    *ngIf="bodaFval.ownersPhoneNumber.valid"
                    class="material-icons"
                  >check_circle</i></label>
                <div class="input-group mb-0">
                  <div class="input-group-prepend">
                    <div class="input-group-text">
                      <i
                        class="fas fa-phone text-primary mx-auto"
                        style="size: 50px;"
                      ></i>
                    </div>
                  </div>
                  <input
                    id="bodaOwnersPhoneNumber"
                    formControlName="ownersPhoneNumber"
                    type="text"
                    placeholder="Bodaboda owner's phone number"
                    class="form-control"
                    [ngClass]="{
                    'is-invalid':
                      (bodaFval.ownersPhoneNumber.touched ||
                      bodaFval.ownersPhoneNumber.dirty) &&
                      bodaFval.ownersPhoneNumber.errors
                  }"
                  />
                </div>
                <div
                  class="text-danger col"
                  *ngIf="
                  (bodaFval.ownersPhoneNumber.touched || bodaFval.ownersPhoneNumber.dirty) &&
                  bodaFval.ownersPhoneNumber.errors?.required
                "
                >
                  Bodaboda owner's phone number is required!
                </div>
                <div
                  class="text-danger col"
                  *ngIf="
              (bodaFval.ownersPhoneNumber.touched ||
              bodaFval.ownersPhoneNumber.dirty) &&
              bodaFval.ownersPhoneNumber.errors?.hasNumber
            "
                >
                  Bodaboda owner's phone number should be equal to 10 "digits"!
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>

    <!-- this is for taxi client -->
    <div [hidden]="!showTaxiForm">
      <div class="container my-2 mx-0 shadow-lg col-12">
        <div class="row">
          <div class="col-12">
            <h4 class="rub-head4 text-info text-center font-weight-bold py-1">
              Taxi Client Info
            </h4>
          </div>
        </div>
      </div>
      <div class="card-body mt-1 pt-4 mb-0 mb-md-3 pb-3 shadow-lg">
        <form [formGroup]="taxiClientForm">
          <div class="row">
            <div class="col-12 col-md-6">
              <div class="form-group text-primary">
                <label
                  for="clientName"
                  [ngClass]="taxiFval.clientName.valid ? 'text-info' : ''"
                >Client Name<i
                    *ngIf="taxiFval.clientName.valid"
                    class="material-icons"
                  >check_circle</i></label>
                <div class="input-group mb-0">
                  <div class="input-group-prepend">
                    <div class="input-group-text">
                      <i
                        class="fas fa-user-alt text-primary mx-auto"
                        style="size: 50px;"
                      >
                      </i>
                    </div>
                  </div>
                  <input
                    type="text"
                    formControlName="clientName"
                    class="form-control"
                    [ngClass]="{
                'is-invalid':
                  (taxiFval.clientName.touched || taxiFval.clientName.dirty) &&
                  taxiFval.clientName.errors
              }"
                    autocomplete="off"
                    placeholder="Enter Customer Name"
                  />
                </div>
                <div
                  class="text-danger col"
                  *ngIf="
              (taxiFval.clientName.touched || taxiFval.clientName.dirty) &&
              taxiFval.clientName.errors?.required
            "
                >
                  The client name is required!
                </div>
              </div>
            </div>
            <div class="col-12 col-md-6">
              <div class="form-group text-primary">
                <label
                  for="drivingPermit"
                  [ngClass]="taxiFval.drivingPermit.valid ? 'text-info' : ''"
                >Driving Permit<i
                    *ngIf="taxiFval.drivingPermit.valid"
                    class="material-icons"
                  >check_circle</i></label>
                <div class="input-group mb-0">
                  <div class="input-group-prepend">
                    <div class="input-group-text">
                      <i
                        class="fas fa-id-card text-primary mx-auto"
                        style="size: 50px;"
                      >
                      </i>
                    </div>
                  </div>
                  <input
                    type="text"
                    formControlName="drivingPermit"
                    class="form-control"
                    [ngClass]="{
                'is-invalid':
                  (taxiFval.drivingPermit.touched || taxiFval.drivingPermit.dirty) &&
                  taxiFval.drivingPermit.errors
              }"
                    autocomplete="off"
                    placeholder="Enter Driving permit number"
                  />
                </div>
                <div
                  class="text-danger col"
                  *ngIf="
              (taxiFval.drivingPermit.touched || taxiFval.drivingPermit.dirty) &&
              taxiFval.drivingPermit.errors?.required
            "
                >
                  The driving permit is required!
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-md-6">
              <div class="form-group text-primary">
                <label
                  for="taxiCustomerNumberPlate"
                  [ngClass]="
                taxiFval.taxiCustomerNumberPlate.valid ? 'text-info' : ''
                "
                >Number Plate<i
                    *ngIf="taxiFval.taxiCustomerNumberPlate.valid"
                    class="material-icons"
                  >check_circle</i></label>
                <div class="input-group mb-0">
                  <div class="input-group-prepend">
                    <div class="input-group-text">
                      <i
                        class="fas fa-tag text-primary mx-auto"
                        style="size: 50px;"
                      ></i>
                    </div>
                  </div>
                  <input
                    type="text"
                    formControlName="taxiCustomerNumberPlate"
                    class="form-control"
                    [ngClass]="{
                    'is-invalid':
                      (taxiFval.taxiCustomerNumberPlate.touched ||
                      taxiFval.taxiCustomerNumberPlate.dirty) &&
                      taxiFval.taxiCustomerNumberPlate.errors
                  }"
                    autocomplete="off"
                    placeholder="Enter Taxi number plate"
                  />
                </div>
                <div
                  class="text-danger col"
                  *ngIf="
                  (taxiFval.taxiCustomerNumberPlate.touched ||
                  taxiFval.taxiCustomerNumberPlate.dirty) &&
                  taxiFval.taxiCustomerNumberPlate.errors?.required
                "
                >
                  The Taxi number plate is required!
                </div>
              </div>
            </div>
            <div class="col-12 col-md-6">
              <div class="form-group text-primary">
                <label
                  for="taxiMakeorType"
                  [ngClass]="
                taxiFval.taxiMakeorType.valid ? 'text-info' : ''
                "
                >Taxi Make Or Type<i
                    *ngIf="taxiFval.taxiMakeorType.valid"
                    class="material-icons"
                  >check_circle</i></label>
                <div class="input-group mb-0">
                  <input
                    type="text"
                    formControlName="taxiMakeorType"
                    class="form-control"
                    [ngClass]="{
                    'is-invalid':
                      (taxiFval.taxiMakeorType.touched ||
                      taxiFval.taxiMakeorType.dirty) &&
                      taxiFval.taxiMakeorType.errors
                  }"
                    autocomplete="off"
                    placeholder="Taxi make or type"
                  />
                </div>
                <div
                  class="text-danger col"
                  *ngIf="
                  (taxiFval.taxiMakeorType.touched ||
                  taxiFval.taxiMakeorType.dirty) &&
                  taxiFval.taxiMakeorType.errors?.required
                "
                >
                  The taxi make/type is required!
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-md-6">
              <div class="form-group text-primary">
                <label
                  for="taxiCustomerFrontPhotoUrl"
                  [ngClass]="taxiFval.taxiCustomerFrontPhotoUrl.valid ? 'text-info' : ''"
                >Front Image<i
                    *ngIf="taxiFval.taxiCustomerFrontPhotoUrl.valid"
                    class="material-icons"
                  >check_circle</i></label>
                <div class="input-group mb-0">
                  <div class="input-group-prepend">
                    <div class="input-group-text">
                      <i
                        class="fas fa-image text-primary mx-auto"
                        style="size: 50px;"
                      ></i>
                    </div>
                  </div>
                  <input
                    id="taxiCustomerFrontPhotoUrl"
                    formControlName="taxiCustomerFrontPhotoUrl"
                    type="file"
                    src="image/*"
                    capture
                    (change)="onFileSelected($event)"
                    class="form-control"
                    [ngClass]="{
                    'is-invalid':
                      (taxiFval.taxiCustomerFrontPhotoUrl.touched ||
                      taxiFval.taxiCustomerFrontPhotoUrl.dirty) &&
                      taxiFval.taxiCustomerFrontPhotoUrl.errors
                  }"
                  />
                </div>
                <div
                  class="text-danger col"
                  *ngIf="
                  (taxiFval.taxiCustomerFrontPhotoUrl.touched || taxiFval.taxiCustomerFrontPhotoUrl.dirty) &&
                  taxiFval.taxiCustomerFrontPhotoUrl.errors?.required
                "
                >
                  Please upload a front image of taxi!
                </div>
              </div>
            </div>
            <div class="col-12 col-md-6">
              <div class="form-group text-primary">
                <label
                  for="taxiCustomerSidePhotoUrl"
                  [ngClass]="taxiFval.taxiCustomerSidePhotoUrl.valid ? 'text-info' : ''"
                >Side Image<i
                    *ngIf="taxiFval.taxiCustomerSidePhotoUrl.valid"
                    class="material-icons"
                  >check_circle</i></label>
                <div class="input-group mb-0">
                  <div class="input-group-prepend">
                    <div class="input-group-text">
                      <i
                        class="fas fa-image text-primary mx-auto"
                        style="size: 50px;"
                      ></i>
                    </div>
                  </div>
                  <input
                    id="taxiCustomerSidePhotoUrl"
                    formControlName="taxiCustomerSidePhotoUrl"
                    type="file"
                    src="image/*"
                    capture
                    (change)="onFileSelected($event)"
                    class="form-control"
                    [ngClass]="{
                    'is-invalid':
                      (taxiFval.taxiCustomerSidePhotoUrl.touched ||
                      taxiFval.taxiCustomerSidePhotoUrl.dirty) &&
                      taxiFval.taxiCustomerSidePhotoUrl.errors
                  }"
                  />
                </div>
                <div
                  class="text-danger col"
                  *ngIf="
                  (taxiFval.taxiCustomerSidePhotoUrl.touched || taxiFval.taxiCustomerSidePhotoUrl.dirty) &&
                  taxiFval.taxiCustomerSidePhotoUrl.errors?.required
                "
                >
                  Please upload a Side image of taxi!
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-md-6">
              <div class="form-group text-primary">
                <label
                  for="taxiCustomerRearPhotoUrl"
                  [ngClass]="taxiFval.taxiCustomerRearPhotoUrl.valid ? 'text-info' : ''"
                >Rear Image<i
                    *ngIf="taxiFval.taxiCustomerRearPhotoUrl.valid"
                    class="material-icons"
                  >check_circle</i></label>
                <div class="input-group mb-0">
                  <div class="input-group-prepend">
                    <div class="input-group-text">
                      <i
                        class="fas fa-image text-primary mx-auto"
                        style="size: 50px;"
                      ></i>
                    </div>
                  </div>
                  <input
                    id="taxiCustomerRearPhotoUrl"
                    formControlName="taxiCustomerRearPhotoUrl"
                    type="file"
                    src="image/*"
                    capture
                    (change)="onFileSelected($event)"
                    class="form-control"
                    [ngClass]="{
                    'is-invalid':
                      (taxiFval.taxiCustomerRearPhotoUrl.touched ||
                      taxiFval.taxiCustomerRearPhotoUrl.dirty) &&
                      taxiFval.taxiCustomerRearPhotoUrl.errors
                  }"
                  />
                </div>
                <div
                  class="text-danger col"
                  *ngIf="
                  (taxiFval.taxiCustomerRearPhotoUrl.touched || taxiFval.taxiCustomerRearPhotoUrl.dirty) &&
                  taxiFval.taxiCustomerRearPhotoUrl.errors?.required
                "
                >
                  Please upload a rear image of taxi!
                </div>
              </div>
            </div>
            <div class="col-12 col-md-6">
              <div class="form-group text-primary">
                <label
                  for="taxiInsuarance"
                  [ngClass]="
                  taxiFval.taxiInsuarance.valid ? 'text-info' : ''
                "
                >Taxi Insurance<i
                    *ngIf="taxiFval.taxiInsuarance.valid"
                    class="material-icons"
                  >check_circle</i></label>
                <div class="input-group mb-0">
                  <select
                    [ngClass]="{
            'is-invalid':
              (taxiFval.taxiInsuarance.touched || taxiFval.taxiInsuarance.dirty) &&
              taxiFval.taxiInsuarance.errors
          }"
                    autocomplete="off"
                    class="form-control"
                    formControlName="taxiInsuarance"
                  >
                    <option
                      class="place-holder-select"
                      disabled
                      hidden
                      selected
                      value=""
                    >Select Insurance Type</option>
                    <option>NONE</option>
                    <option>REGULAR</option>
                    <option>COMPREHENSIVE</option>
                  </select>
                </div>
                <div
                  class="text-danger col"
                  *ngIf="
                  (taxiFval.taxiInsuarance.touched ||
                  taxiFval.taxiInsuarance.dirty) &&
                  taxiFval.taxiInsuarance.errors?.required
                "
                >
                  The taxi insurance is required!
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-md-6">
              <div class="form-group text-primary">
                <label
                  for="taxiStage"
                  [ngClass]="
                taxiFval.taxiStage.valid ? 'text-info' : ''
                "
                >Taxi Stage<i
                    *ngIf="taxiFval.taxiStage.valid"
                    class="material-icons"
                  >check_circle</i></label>
                <div class="input-group mb-0">
                  <input
                    type="text"
                    list="taxiStage"
                    formControlName="taxiStage"
                    class="form-control"
                    [ngClass]="{
                  'is-invalid':
                    (taxiFval.taxiStage.touched ||
                    taxiFval.taxiStage.dirty) &&
                    taxiFval.taxiStage.errors
                }"
                    autocomplete="off"
                    placeholder="Select a taxi stage"
                  />
                  <!-- parks -->
                  <datalist id="taxiStage">
                    <option *ngFor="let taxiStage of taxiStages">
                      {{ taxiStage.taxiStageName }}
                    </option>
                  </datalist>
                </div>
                <div
                  class="text-danger col"
                  *ngIf="
                  (taxiFval.taxiStage.touched ||
                  taxiFval.taxiStage.dirty) &&
                  taxiFval.taxiStage.errors?.required
                "
                >
                  Taxi stage is required!
                </div>
              </div>
            </div>
            <div class="col-12 col-md-6">
              <div class="form-group text-primary">
                <label
                  for="dateOfJoiningStage"
                  [ngClass]="
                taxiFval.dateOfJoiningStage.valid
                    ? 'text-info'
                    : ''
                "
                >Date Of Joining Stage<i
                    *ngIf="taxiFval.dateOfJoiningStage.valid"
                    class="material-icons"
                  >check_circle</i></label>
                <div class="input-group mb-0">
                  <div class="input-group-prepend">
                    <div class="input-group-text">
                      <i
                        class="fas fa-calendar-alt text-primary mx-auto"
                        style="size: 50px;"
                      ></i>
                    </div>
                  </div>
                  <input
                    id="taxiDateOfJoiningStage"
                    formControlName="dateOfJoiningStage"
                    type="text"
                    class="form-control"
                    [ngClass]="{
                    'is-invalid':
                      (taxiFval.dateOfJoiningStage.touched || taxiFval.dateOfJoiningStage.dirty) &&
                      taxiFval.dateOfJoiningStage.errors
                  }"
                    placeholder="Click to select Date"
                    autocomplete="off"
                    bsDatepicker
                    [bsConfig]="{ containerClass:'theme-blue', dateInputFormat: 'MM/DD/YYYY', isAnimated: true }"
                    placement="top"
                  />
                </div>
                <div
                  class="text-danger col"
                  *ngIf="
                  (taxiFval.dateOfJoiningStage.touched ||
                  taxiFval.dateOfJoiningStage.dirty) &&
                  taxiFval.dateOfJoiningStage.errors?.required
                "
                >
                  Date of joining stage is required!
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-md-6">
              <div class="form-group text-primary">
                <label
                  for="ownershipStatus"
                  [ngClass]="taxiFval.ownershipStatus.valid ? 'text-info' : ''"
                >Taxi Ownership Status<i
                    *ngIf="taxiFval.ownershipStatus.valid"
                    class="material-icons"
                  >check_circle</i></label>
                <div class="input-group mb-0">
                  <select
                    (change)='setSelectedChanges(taxiFval.ownershipStatus.value)'
                    [ngClass]="{
            'is-invalid':
              (taxiFval.ownershipStatus.touched || taxiFval.ownershipStatus.dirty) &&
             taxiFval.ownershipStatus.errors
          }"
                    autocomplete="off"
                    class="form-control"
                    formControlName="ownershipStatus"
                  >
                    <option
                      class="place-holder-select"
                      disabled
                      hidden
                      selected
                      value=""
                    >Select Status</option>
                    <option>ONLOAN</option>
                    <option>PAIDOUT</option>
                    <option>HIREDOUT</option>
                  </select>
                </div>
                <div
                  class="text-danger col"
                  *ngIf="
                  (taxiFval.ownershipStatus.touched || taxiFval.ownershipStatus.dirty) &&
                  taxiFval.ownershipStatus.errors?.required
                "
                >
                  Taxi ownership status is required!
                </div>
              </div>
            </div>
          </div>
          <div
            class="row"
            *ngIf="taxiFval.ownershipStatus.value == 'ONLOAN' || taxiFval.ownershipStatus.value == 'HIREDOUT' "
          >
            <div class="col-12 col-md-6">
              <div class="form-group text-primary">
                <label
                  for="taxiOwnersName"
                  [ngClass]="taxiFval.ownersName.valid ? 'text-info' : ''"
                >Taxi Owner's Name<i
                    *ngIf="taxiFval.ownersName.valid"
                    class="material-icons"
                  >check_circle</i></label>
                <div class="input-group mb-0">
                  <div class="input-group-prepend">
                    <div class="input-group-text">
                      <i
                        class="fas fa-user-alt text-primary mx-auto"
                        style="size: 50px;"
                      ></i>
                    </div>
                  </div>
                  <input
                    id="taxiOwnersName"
                    formControlName="ownersName"
                    type="text"
                    placeholder="Taxi owner's name"
                    class="form-control"
                    [ngClass]="{
                    'is-invalid':
                      (taxiFval.ownersName.touched ||
                      taxiFval.ownersName.dirty) &&
                      taxiFval.ownersName.errors
                  }"
                  />
                </div>
                <div
                  class="text-danger col"
                  *ngIf="
                  (taxiFval.ownersName.touched || taxiFval.ownersName.dirty) &&
                  taxiFval.ownersName.errors?.required
                "
                >
                  Taxi owner's name is required!
                </div>
              </div>
            </div>
            <div class="col-12 col-md-6">
              <div class="form-group text-primary">
                <label
                  for="taxiOwnersPhoneNumber"
                  [ngClass]="taxiFval.ownersPhoneNumber.valid ? 'text-info' : ''"
                >Taxi Owner's Phone Number<i
                    *ngIf="taxiFval.ownersPhoneNumber.valid"
                    class="material-icons"
                  >check_circle</i></label>
                <div class="input-group mb-0">
                  <div class="input-group-prepend">
                    <div class="input-group-text">
                      <i
                        class="fas fa-phone text-primary mx-auto"
                        style="size: 50px;"
                      ></i>
                    </div>
                  </div>
                  <input
                    id="taxiOwnersPhoneNumber"
                    formControlName="ownersPhoneNumber"
                    type="text"
                    placeholder="Taxi owner's phone number"
                    class="form-control"
                    [ngClass]="{
                    'is-invalid':
                      (taxiFval.ownersPhoneNumber.touched ||
                      taxiFval.ownersPhoneNumber.dirty) &&
                      taxiFval.ownersPhoneNumber.errors
                  }"
                  />
                </div>
                <div
                  class="text-danger col"
                  *ngIf="
                  (taxiFval.ownersPhoneNumber.touched || taxiFval.ownersPhoneNumber.dirty) &&
                  taxiFval.ownersPhoneNumber.errors?.required
                "
                >
                  Taxi owner's phone number is required!
                </div>
                <div
                  class="text-danger col"
                  *ngIf="
                (taxiFval.ownersPhoneNumber.touched ||
                taxiFval.ownersPhoneNumber.dirty) &&
                taxiFval.ownersPhoneNumber.errors?.hasNumber
              "
                >
                  Taxi owner's phone number should be equal to 10 "digits"!
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>

    <!-- this is for micro client -->
    <div [hidden]="!showMicroForm">
      <div class="container my-2 mx-0 shadow-lg col-12">
        <div class="row">
          <div class="col-12">
            <h4 class="rub-head4 text-info text-center font-weight-bold py-1">
              Micro Client Info
            </h4>
          </div>
        </div>
      </div>
      <div class="card-body mt-1 pt-4 mb-0 mb-md-3 pb-3 shadow-lg">
        <form [formGroup]="microClientForm">
          <div class="row">
            <div class="col-12 col-md-6">
              <div class="form-group text-primary">
                <label
                  for="clientName"
                  [ngClass]="microFval.clientName.valid ? 'text-info' : ''"
                >Client Name<i
                    *ngIf="microFval.clientName.valid"
                    class="material-icons"
                  >check_circle</i></label>
                <div class="input-group mb-0">
                  <div class="input-group-prepend">
                    <div class="input-group-text">
                      <i
                        class="fas fa-user-alt text-primary mx-auto"
                        style="size: 50px;"
                      >
                      </i>
                    </div>
                  </div>
                  <input
                    type="text"
                    formControlName="clientName"
                    class="form-control"
                    [ngClass]="{
                'is-invalid':
                  (microFval.clientName.touched || microFval.clientName.dirty) &&
                  microFval.clientName.errors
              }"
                    autocomplete="off"
                    placeholder="Enter Customer Name"
                  />
                </div>
                <div
                  class="text-danger col"
                  *ngIf="
                (microFval.clientName.touched || microFval.clientName.dirty) &&
                microFval.clientName.errors?.required
              "
                >
                  The client name is required!
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-md-6">
              <div class="form-group text-primary">
                <label
                  for="currentBusinesstype"
                  [ngClass]="
                microFval.currentBusinesstype.valid ? 'text-info' : ''
                "
                >Current Business<i
                    *ngIf="microFval.currentBusinesstype.valid"
                    class="material-icons"
                  >check_circle</i></label>
                <div class="input-group mb-0">
                  <input
                    type="text"
                    formControlName="currentBusinesstype"
                    class="form-control"
                    [ngClass]="{
                    'is-invalid':
                      (microFval.currentBusinesstype.touched ||
                      microFval.currentBusinesstype.dirty) &&
                      microFval.currentBusinesstype.errors
                  }"
                    autocomplete="off"
                    placeholder="Current business type"
                  />
                </div>
                <div
                  class="text-danger col"
                  *ngIf="
                  (microFval.currentBusinesstype.touched ||
                  microFval.currentBusinesstype.dirty) &&
                  microFval.currentBusinesstype.errors?.required
                "
                >
                  The current business type is required!
                </div>
              </div>
            </div>
            <div class="col-12 col-md-6">
              <div class="form-group text-primary">
                <label
                  for="businessLocation"
                  [ngClass]="
                microFval.businessLocation.valid ? 'text-info' : ''
                "
                >Business Location<i
                    *ngIf="microFval.businessLocation.valid"
                    class="material-icons"
                  >check_circle</i></label>
                <div class="input-group mb-0">
                  <div class="input-group-prepend">
                    <div class="input-group-text">
                      <i
                        class="fas fa-map-marker-alt text-primary mx-auto"
                        style="size: 50px;"
                      >
                      </i>
                    </div>
                  </div>
                  <input
                    type="text"
                    formControlName="businessLocation"
                    class="form-control"
                    [ngClass]="{
                    'is-invalid':
                      (microFval.businessLocation.touched ||
                      microFval.businessLocation.dirty) &&
                      microFval.businessLocation.errors
                  }"
                    autocomplete="off"
                    placeholder="Business location"
                  />
                </div>
                <div
                  class="text-danger col"
                  *ngIf="
                  (microFval.businessLocation.touched ||
                  microFval.businessLocation.dirty) &&
                  microFval.businessLocation.errors?.required
                "
                >
                  The business location is required!
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-md-6">
              <div class="form-group text-primary">
                <label
                  for="averageDailyExpenses"
                  [ngClass]="
                microFval.averageDailyExpenses.valid ? 'text-info' : ''
                "
                >Average Daily Expenses<i
                    *ngIf="microFval.averageDailyExpenses.valid"
                    class="material-icons"
                  >check_circle</i></label>
                <div class="input-group mb-0">
                  <input
                    type="text"
                    id="averageDailyExpenses"
                    formControlName="averageDailyExpenses"
                    class="form-control"
                    [ngClass]="{
                    'is-invalid':
                      (microFval.averageDailyExpenses.touched ||
                      microFval.averageDailyExpenses.dirty) &&
                      microFval.averageDailyExpenses.errors
                  }"
                    autocomplete="off"
                    placeholder="Average daily expenses"
                    (keyup)="onKey($event)"
                  />
                </div>
                <div
                  class="text-danger col"
                  *ngIf="
                  (microFval.averageDailyExpenses.touched ||
                  microFval.averageDailyExpenses.dirty) &&
                  microFval.averageDailyExpenses.errors?.required
                "
                >
                  The average daily expenses are required!
                </div>
              </div>
            </div>
            <div class="col-12 col-md-6">
              <div class="form-group text-primary">
                <label
                  for="averageDailyIncome"
                  [ngClass]="
                microFval.averageDailyIncome.valid ? 'text-info' : ''
                "
                >Average Daily Income<i
                    *ngIf="microFval.averageDailyIncome.valid"
                    class="material-icons"
                  >check_circle</i></label>
                <div class="input-group mb-0">
                  <input
                    type="text"
                    formControlName="averageDailyIncome"
                    class="form-control"
                    [ngClass]="{
                    'is-invalid':
                      (microFval.averageDailyIncome.touched ||
                      microFval.averageDailyIncome.dirty) &&
                      microFval.averageDailyIncome.errors
                  }"
                    autocomplete="off"
                    placeholder="Average daily income"
                    (keyup)="onKey($event)"
                  />
                </div>
                <div
                  class="text-danger col"
                  *ngIf="
                  (microFval.averageDailyIncome.touched ||
                  microFval.averageDailyIncome.dirty) &&
                  microFval.averageDailyIncome.errors?.required
                "
                >
                  Average daily income is required!
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-md-6">
              <div class="form-group text-primary">
                <label
                  for="currentResidence"
                  [ngClass]="
                microFval.currentResidence.valid
                    ? 'text-info'
                    : ''
                "
                >Current Residence<i
                    *ngIf="microFval.currentResidence.valid"
                    class="material-icons"
                  >check_circle</i></label>
                <div class="input-group mb-0">
                  <div class="input-group-prepend">
                    <div class="input-group-text">
                      <i
                        class="fas fa-location-arrow text-primary mx-auto"
                        style="size: 50px;"
                      >
                      </i>
                    </div>
                  </div>
                  <input
                    type="text"
                    formControlName="currentResidence"
                    class="form-control"
                    [ngClass]="{
                    'is-invalid':
                      (microFval.currentResidence.touched ||
                      microFval.currentResidence.dirty) &&
                      microFval.currentResidence.errors
                  }"
                    autocomplete="off"
                    placeholder="Current residence"
                  />
                </div>
                <div
                  class="text-danger col"
                  *ngIf="
                  (microFval.currentResidence.touched ||
                  microFval.currentResidence.dirty) &&
                  microFval.currentResidence.errors?.required
                "
                >
                  Current residence is required!
                </div>
              </div>
            </div>
            <div class="col-12 col-md-6">
              <div class="form-group text-primary">
                <label
                  for="residenceStatus"
                  [ngClass]="
                microFval.residenceStatus.valid
                    ? 'text-info'
                    : ''
                "
                >Residence Status<i
                    *ngIf="microFval.residenceStatus.valid"
                    class="material-icons"
                  >check_circle</i></label>
                <div class="input-group mb-0">
                  <select
                    [ngClass]="{
            'is-invalid':
              (microFval.residenceStatus.touched ||microFval.residenceStatus.dirty) &&
           microFval.residenceStatus.errors
          }"
                    autocomplete="off"
                    class="form-control"
                    formControlName="residenceStatus"
                  >
                    <option
                      class="place-holder-select"
                      disabled
                      hidden
                      selected
                      value=""
                    >Select Residence Status</option>
                    <option>LANDLORD</option>
                    <option>TENANT</option>
                  </select>
                </div>
                <div
                  class="text-danger col"
                  *ngIf="
                  (microFval.residenceStatus.touched ||
                  microFval.residenceStatus.dirty) &&
                  microFval.residenceStatus.errors?.required
                "
                >
                  Residence status is required!
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-md-6">
              <div class="form-group text-primary">
                <label
                  for="numberOfDependants"
                  [ngClass]="microFval.numberOfDependants.valid ? 'text-info' : ''"
                >Number Of Dependants<i
                    *ngIf="microFval.numberOfDependants.valid"
                    class="material-icons"
                  >check_circle</i></label>
                <div class="input-group mb-0">
                  <input
                    id="numberOfDependants"
                    formControlName="numberOfDependants"
                    type="number"
                    min='0'
                    class="form-control"
                    [ngClass]="{
                    'is-invalid':
                      (microFval.numberOfDependants.touched ||
                      microFval.numberOfDependants.dirty) &&
                      microFval.numberOfDependants.errors
                  }"
                    placeholder="Number of dependants"
                  />
                </div>
                <div
                  class="text-danger col"
                  *ngIf="
                  (microFval.numberOfDependants.touched || microFval.numberOfDependants.dirty) &&
                  microFval.numberOfDependants.errors?.required
                "
                >
                  Number of dependants is required!
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>

    <!-- this is for savings client -->
    <div [hidden]="!showSaveForm">
      <div class="container my-2 mx-0 shadow-lg col-12">
        <div class="row">
          <div class="col-12">
            <h4 class="rub-head4 text-info text-center font-weight-bold py-1">
              Savings Client Info
            </h4>
          </div>
        </div>
      </div>
      <div class="card-body mt-1 pt-4 mb-0 mb-md-3 pb-3 shadow-lg">
        <form [formGroup]="savingsClientForm">
          <div class="row">
            <div class="col-12 col-md-6">
              <div class="form-group text-primary">
                <label
                  for="clientName"
                  [ngClass]="savFval.clientName.valid ? 'text-info' : ''"
                >Client Name<i
                    *ngIf="savFval.clientName.valid"
                    class="material-icons"
                  >check_circle</i></label>
                <div class="input-group mb-0">
                  <div class="input-group-prepend">
                    <div class="input-group-text">
                      <i
                        class="fas fa-user-alt text-primary mx-auto"
                        style="size: 50px;"
                      >
                      </i>
                    </div>
                  </div>
                  <input
                    type="text"
                    formControlName="clientName"
                    class="form-control"
                    [ngClass]="{
                'is-invalid':
                  (savFval.clientName.touched || savFval.clientName.dirty) &&
                  savFval.clientName.errors
              }"
                    autocomplete="off"
                    placeholder="Enter Customer Name"
                  />
                </div>
                <div
                  class="text-danger col"
                  *ngIf="
                (savFval.clientName.touched || savFval.clientName.dirty) &&
                savFval.clientName.errors?.required
              "
                >
                  The customer name is required!
                </div>
              </div>
            </div>
            <div class="col-12 col-md-6">
              <div class="form-group text-primary">
                <label
                  for="monthlyIncome"
                  [ngClass]="
              savFval.monthlyIncome.valid ? 'text-info' : ''
              "
                >Monthly Income<i
                    *ngIf="savFval.monthlyIncome.valid"
                    class="material-icons"
                  >check_circle</i></label>
                <div class="input-group mb-0">
                  <input
                    type="text"
                    formControlName="monthlyIncome"
                    class="form-control"
                    [ngClass]="{
                  'is-invalid':
                    (savFval.monthlyIncome.touched ||
                    savFval.monthlyIncome.dirty) &&
                    savFval.monthlyIncome.errors
                }"
                    autocomplete="off"
                    placeholder="Monthly income"
                    (keyup)="onKey($event)"
                  />
                </div>
                <div
                  class="text-danger col"
                  *ngIf="
                (savFval.monthlyIncome.touched ||
                savFval.monthlyIncome.dirty) &&
                savFval.monthlyIncome.errors?.required
              "
                >
                  The monthly income is required!
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-md-6">
              <div class="form-group text-primary">
                <label
                  for="withdrawFreequency"
                  [ngClass]="
                savFval.withdrawFreequency.valid ? 'text-info' : ''
                "
                >Withdraw Frequency<i
                    *ngIf="savFval.withdrawFreequency.valid"
                    class="material-icons"
                  >check_circle</i></label>
                <div class="input-group mb-0">
                  <input
                    type="number"
                    min='0'
                    formControlName="withdrawFreequency"
                    class="form-control"
                    [ngClass]="{
                    'is-invalid':
                      (savFval.withdrawFreequency.touched ||
                      savFval.withdrawFreequency.dirty) &&
                      savFval.withdrawFreequency.errors
                  }"
                    autocomplete="off"
                    placeholder="Withraw frequency"
                  />
                </div>
                <div
                  class="text-danger col"
                  *ngIf="
                  (savFval.withdrawFreequency.touched ||
                  savFval.withdrawFreequency.dirty) &&
                  savFval.withdrawFreequency.errors?.required
                "
                >
                  Withdraw frequency is required!
                </div>
              </div>
            </div>
            <div class="col-12 col-md-6">
              <div class="form-group text-primary">
                <label
                  for="customerTarget"
                  [ngClass]="
                savFval.customerTarget.valid ? 'text-info' : ''
                "
                >Customer's Target<i
                    *ngIf="savFval.customerTarget.valid"
                    class="material-icons"
                  >check_circle</i></label>
                <div class="input-group mb-0">
                  <input
                    type="text"
                    formControlName="customerTarget"
                    class="form-control"
                    [ngClass]="{
                    'is-invalid':
                      (savFval.customerTarget.touched ||
                      savFval.customerTarget.dirty) &&
                      savFval.customerTarget.errors
                  }"
                    autocomplete="off"
                    placeholder="Customer's target"
                  />
                </div>
                <div
                  class="text-danger col"
                  *ngIf="
                ( savFval.customerTarget.touched ||
                  savFval.customerTarget.dirty) &&
                  savFval.customerTarget.errors?.required
                "
                >
                  Customer's target is required!
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>

    <!-- action buttons -->
    <div class="d-flex mt-3 mb-2 mb-xl-0 py-2 mx-auto">
      <button
        type="button"
        class="btn btn-info col-5 col-md-3 mx-auto"
        *ngIf="userForm.valid && this.fval.productCode.value != '' && showcompleteBtn"
        (click)="nextForm()"
      >
        Go To {{this.fval.productCode.value == 200 ? 'BodaLoan' :
        this.fval.productCode.value == 300 ? 'TaxiLoan' :
        this.fval.productCode.value == 400 ? 'MicroLoan' : 'Savings' }} Form
      </button>
      <button
        type="button"
        class="btn btn-info col-5 col-md-3 mx-auto"
        *ngIf="!showPersonalForm"
        (click)="goBack()"
      >
        Back
      </button>
      <ngx-spinner
        class="bg-info"
        size="medium"
        type="ball-scale-multiple"
      >
        <p class="text-light">Please wait...</p>
      </ngx-spinner>

      <label
        class="col text-danger"
        *ngIf="errored"
      >
        <!-- <i class="material-icons">Cancel</i> -->

        <ngx-alerts></ngx-alerts>
      </label>

      <label
        class="col text-info"
        *ngIf="posted"
      >
        <!-- <i class="material-icons">check_circle</i> -->
        <ngx-alerts></ngx-alerts>
      </label>

      <button
        type="button"
        class="btn btn-info col-5 col-md-3 mx-auto"
        routerLink='/townmanagement'
        *ngIf="showPersonalForm"
      >
        Cancel
      </button>
      <button
        type="button"
        class="btn btn-info col-5 col-md-3 mx-auto"
        *ngIf="showFinalBtn"
        (click)="save()"
      >
        Finish
      </button>
    </div>
  </div>
</div>

<ng-template #dataModal>
  <app-data-modal
    [title]="modalTitle"
    [dataKind]="selectionKind"
    (result)="getResult($event)"
    [data]="selectionData"
    (close)="getClose($event)"
  ></app-data-modal>
</ng-template>
